import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: React.ReactNode
  backHref?: string
  size?: 'default' | 'sm'
  className?: string
}

export function PageHeader({
  title,
  description,
  actions,
  backHref,
  size = 'default',
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}
    >
      <div className="flex items-start gap-3">
        {backHref && (
          <Button variant="ghost" size="icon" className="shrink-0 -ml-2 mt-0.5" asChild>
            <Link to={backHref}>
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </Button>
        )}
        <div>
          <h1
            className={cn(
              'font-semibold tracking-tight font-display',
              size === 'sm' ? 'text-lg' : 'text-2xl'
            )}
          >
            {title}
          </h1>
          {description && <p className="text-[13px] text-muted-foreground mt-0.5">{description}</p>}
        </div>
      </div>
      {actions && (
        <div className="flex w-full items-center gap-2 sm:w-auto sm:shrink-0">{actions}</div>
      )}
    </div>
  )
}
